// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-custom_pagination_class {\n  border: none;\n  background-color: transparent !important;\n}\n.custom-title {\n  font-size: 32px;\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
